import { Component } from '@angular/core';

@Component({
  standalone: false,
  template: `
    <div class="small-12 medium-12 large-12 columns m-5">
      <div class="row">
        <div class="col">
          <div class="alert alert-danger" role="alert">
            <span class="alert-icon material-icons-round">warning</span>
            <div class="alert-content">Please contact your Managed Care Executive or Payor Solutions Executive to get access to the appropriate reporting.</div>
          </div>
        </div>
      </div>
  `
})
export class SetupRequiredComponent { }
